<script>
    import TicketPluginModalContent from "./TicketPluginModalContent.svelte"

    let params = {}                 // used to share with child, format { "Gold": XXX, "AnotherBooster": YYY }, all names are in ModalContent.svelte

    export function getParams() {
        return Object.keys(params).length > 0 ? params : undefined
    }

    export function assignParams(p) {
        params = p ?? {}
    }

    export function resetParams() {
        params = {}
    }

	import {afterUpdate} from 'svelte'
	afterUpdate(async () => {
        M.Modal.init(document.querySelectorAll('.modal'))
	})
</script>


<div class="plugin-container">
    <div class="flex-row">
        {#each Object.entries(params) as [name, value]}
            {#if value > 0}
                <div class="chip"><img src={`items/${name}.png`} alt={name}> {value}</div>                            
            {/if}
        {/each}

        <!-- Modal Trigger -->
        <a class="modal-trigger" href="#modal-edit-items">Edit items...</a>

        <!-- Modal Structure -->
        <div id="modal-edit-items" class="modal">
            <TicketPluginModalContent bind:params={params} />
        </div>    
    </div>
</div>


<style>
    .plugin-container {
        margin-left: 50px;
        position: relative;
        top: 20px;
    }

    .flex-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .modal-trigger {
        margin-left: 9px;
    }
</style>